import { toApiError } from './api-error.ts'
import { api } from './api.ts'
import type { PageAudience } from './pages.ts'

/**
 * Read one answer from `GET /viewer-access`.
 *
 * Only a literal `true` grants an audience. The backend answers `false` with
 * a `reason` when its lookup fails, and anything else reads the same way.
 *
 * @param answer - The parsed JSON body.
 * @returns The viewer's access.
 */
export function parseViewerAccess(answer: unknown): PageAudience[] {
  if (typeof answer !== 'object' || answer === null) {
    return []
  }
  const audiences = 'audiences' in answer ? answer.audiences : null
  return Array.isArray(audiences)
    ? audiences.filter(
        (value): value is PageAudience => value === 'engineering'
      )
    : []
}

/**
 * Ask the backend which audiences the signed-in employee belongs to.
 *
 * @returns The viewer's access.
 * @throws {ApiRequestError} when the backend refuses or does not answer.
 */
export async function fetchViewerAccess(): Promise<PageAudience[]> {
  try {
    return parseViewerAccess(await api.get('viewer-access').json())
  } catch (error) {
    throw await toApiError(error)
  }
}
